import { mutations } from './concierge.d';

export default {
  /**
   * Initialize Current Concierge
   */
  [mutations.setCurrentConcierge](state, concierge) {
    state.currentConcierge = concierge;
  },

  /**
   * Update Current Concierge
   */
  [mutations.updateCurrentConcierge](state, concierge) {
    state.currentConcierge = concierge;
  },

  /**
   * Update online status for Current Concierge
   */
  [mutations.updateConciergeOnlineStatus](state, status) {
    state.currentConcierge.is_online = status;
  },

  /**
   * Initialize concierge list
   */
  [mutations.setConciergeList](state, conciergeList) {
    state.conciergeList = conciergeList;
  },

  /**
   * Update concierge list
   */
  [mutations.updateConciergeList](state, conciergeList) {
    state.conciergeList = conciergeList;
  },

  [mutations.updateConciergeChannel](state, payload) {
    state.conciergeChannels[payload.conciergeId] = payload.conciergeChannels;
  },

  /**
   * Set Concierge Rewards
   */
  [mutations.setConciergeRewards](state, rewards) {
    state.conciergeRewards = rewards;
  },

  /**
   * Set Concierge Unique Users
   */
  [mutations.setConciergeUniqueUsers](state, uniqueUsers) {
    state.conciergeUniqueUsers = uniqueUsers;
  },

  /**
   * Set Concierge Chats
   */
  [mutations.setConciergeChats](state, chats) {
    state.conciergeChats = chats;
  },

  /**
   * Set Concierge Profile Visits
   */
  [mutations.setConciergeProfileVisits](state, visits) {
    state.conciergeProfileVisits = visits;
  }
};
